import axios from "axios";
const URL = process.env.REACT_APP_API_URL;

export const favoriteService = (userId: string) => {
  return axios.get(`${URL}/favorite-profile/${userId}`);
};

export interface IFilledFields {
  name: string;
  shortName: string;
  value: number;
}

export interface IFavoriteReq {
  profileType: string;
  filledFields: IFilledFields[];
  popularId: string;
}

export const addFavoriteService = (userId: string, payload: IFavoriteReq) => {
  return axios.post(`${URL}/favorite-profile/${userId}`, payload);
};

export const deleteFavoriteService = (favoriteId) => {
  return axios.delete(`${URL}/favorite-profile/${favoriteId}`);
};
